<template>
  <b-nav  class="nav-inline flex-row">
    <b-button @click="$router.push('/applicants')" class="breadcrumb-back-btn b-left" size="sm" variant="link"><i
      class="fa fa-chevron-left fa-fw" aria-hidden="true"></i>
    </b-button>
    <b-nav-item :to="{name:Rn.RN_APPLICANT_BASIC}">
      <i class="fa fa-user fa-fw"></i>
      {{$t('DATA_OF_APPLICANT')}}
    </b-nav-item>
    <b-nav-item :to="{name:Rn.RN_RECOGNITION_DATA}">
      <i class="fa fa-th-list"></i>
      {{$t('ORIGIN_OF_QUALIFICATION')}}
    </b-nav-item>
    <b-nav-item :to="{name:Rn.RN_RECOGNITION_EVALUATION_DATA}">
      <i class="fa fa-th-list"></i>
      {{$t('EVALUATION_INFORMATION')}}
    </b-nav-item>
    <b-nav-item :to="{name:Rn.RN_RECOGNITION_DECISION_DATA}">
      <i class="fa fa-th-list"></i>
      {{$t('RECOGNITION_DECISION')}}
    </b-nav-item>
    <b-nav-item :to="{name:Rn.RN_APPLICANT_DOCUMENT}" >
      <i class="fa fa-file fa-fw"></i>
      {{$t('DOCUMENTS')}}
    </b-nav-item>
    <b-nav-item :to="{name:Rn.RN_RECOGNITION_DECISION_DOCUMENT}">
      <i class="fa fa-file-pdf-o fa-fw"></i>
      {{$t('DECISION_DOCUMENT')}}
    </b-nav-item>
  </b-nav>
</template>

<script>

  import routeNames from '@/router/routeNames'
    export default {
        name: "Index",
      data(){
          return {
            Rn: routeNames,
          }
      },

    }
</script>

<style scoped>
.b-left {
  margin-left: -36px;
}
</style>
